<script setup>
import { onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';

const store = useStore();


onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
});

onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
});
</script>

<template>
  <div class="privacy-policy">
    <div class="container">
      <h1 class="title">Declaración de Privacidad</h1>

      <section>
        <p>
          Mi Licencia está comprometido a proteger tu privacidad y a desarrollar tecnología que te brinde la experiencia en línea más segura y eficiente. Esta Declaración de Privacidad aplica al sitio de Mi Licencia y rige la recolección y uso de datos. Al utilizar el sitio de Mi Licencia, aceptas las prácticas de datos descritas en esta declaración.
        </p>
      </section>

      <section>
        <h2>Recolección de tu Información Personal</h2>
        <p>
          Mi Licencia recopila información de identificación personal, como tu dirección de correo electrónico, nombre, dirección de casa o trabajo, y número de teléfono. También se recopila información demográfica anónima, que no es exclusiva de ti, como tu código postal, edad, género, preferencias, intereses y hábitos de salud.
        </p>
        <p>
          Además, Mi Licencia recopila automáticamente información sobre tu hardware y software, como tu dirección IP, tipo de navegador, nombres de dominio, tiempos de acceso y direcciones de sitios web de referencia. Esta información se utiliza para operar el servicio, mantener la calidad del servicio y proporcionar estadísticas generales sobre el uso del sitio de Mi Licencia.
        </p>
      </section>

      <section>
        <h2>Uso de tu Información Personal</h2>
        <p>
          Mi Licencia recopila y utiliza tu información personal para operar el sitio web y ofrecerte los servicios solicitados, como recursos de salud y seguridad en el trabajo. También utilizamos tu información para informarte sobre otros productos o servicios disponibles de Mi Licencia y sus afiliados.
        </p>
        <p>
          Mi Licencia no vende, alquila ni cede sus listas de clientes a terceros. Es posible que contactemos contigo en nombre de socios comerciales externos, pero tu información personal no se transferirá al tercero.
        </p>
      </section>

      <section>
        <h2>Uso de Cookies</h2>
        <p>
          El sitio web de Mi Licencia utiliza "cookies" para personalizar tu experiencia en línea. Puedes optar por aceptar o rechazar cookies a través de la configuración de tu navegador.
        </p>
      </section>

      <section>
        <h2>Seguridad de tu Información Personal</h2>
        <p>
          Mi Licencia protege tu información personal contra el acceso, uso o divulgación no autorizados mediante servidores seguros y tecnologías como el cifrado SSL.
        </p>
      </section>

      <section>
        <h2>Cambios a esta Declaración</h2>
        <p>
          Mi Licencia puede actualizar esta Declaración de Privacidad ocasionalmente para reflejar cambios en nuestras políticas o en la retroalimentación de nuestros usuarios.
        </p>
      </section>

      <section>
        <h2>Información de Contacto</h2>
        <p>
          Si tienes algún comentario sobre esta Declaración de Privacidad, por favor contáctanos a través de notificacion_ocupacional@med.unne.edu.ar.
        </p>
      </section>
    </div>
  </div>
</template>

<style scoped>

.privacy-policy {
  padding: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.title {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 20px;
}

h2 {
  font-size: 1.5rem;
  margin-top: 20px;
}

p {
  line-height: 1.6;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.25rem;
  }

  .container {
    padding: 15px;
  }
}
</style>
